import { t } from '@lingui/core/macro';
import { TireQuoteRejectionReason } from '@navio/nsdk';
import { NoddiCheckbox } from 'noddi-ui-web';

const REASONS: TireQuoteRejectionReason[] = [
  TireQuoteRejectionReason.ALREADY_BOUGHT,
  TireQuoteRejectionReason.PRICE_TOO_HIGH,
  TireQuoteRejectionReason.BUYING_ELSEWHERE,
  TireQuoteRejectionReason.SELLING_CAR,
  TireQuoteRejectionReason.OTHER
];

const getRejectionReasonLabel = (reason: TireQuoteRejectionReason) => {
  switch (reason) {
    case TireQuoteRejectionReason.ALREADY_BOUGHT:
      return t`Already bought tires`;
    case TireQuoteRejectionReason.PRICE_TOO_HIGH:
      return t`Too expensive`;
    case TireQuoteRejectionReason.BUYING_ELSEWHERE:
      return t`Buying tires elsewhere`;
    case TireQuoteRejectionReason.TIRES_GOOD_ENOUGH:
      return t`My tires are good enough`;
    case TireQuoteRejectionReason.SELLING_CAR:
      return t`Selling the car`;
    case TireQuoteRejectionReason.OTHER:
      return t`Other`;
  }
};

type Props = {
  value: TireQuoteRejectionReason[];
  onChange: (value: TireQuoteRejectionReason[]) => void;
};

/** Every reason that applies, as checkboxes: declining often has more than one. */
export const RejectionReasonPicker = ({ value, onChange }: Props) => (
  <div className='flex flex-col gap-4'>
    {REASONS.map((reason) => (
      <NoddiCheckbox
        key={reason}
        label={getRejectionReasonLabel(reason)}
        checked={value.includes(reason)}
        onCheckedChange={(checked) => onChange(checked ? [...value, reason] : value.filter((item) => item !== reason))}
      />
    ))}
  </div>
);
